import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { ContainerTransactionStatus } from 'src/app/core/models/container-transaction-status';
import { ContainerTransactionStatusService } from 'src/app/core/services/general/container-transaction-status.service';

@Component({
  selector: 'app-container-transaction-status-input',
  templateUrl: './container-transaction-status-input.component.html',
  styleUrls: ['./container-transaction-status-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ContainerTransactionStatusInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ContainerTransactionStatusInputComponent,
    },
  ],
})
export class ContainerTransactionStatusInputComponent {
  @Input()
  title = "Select Transaction Status...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public containerTransactionStatussList: Array<CustomSelectOption> = [];

  constructor(
    private containerTransactionStatusService: ContainerTransactionStatusService,
  ) {
    this.containerTransactionStatusService
      .all()
      .subscribe((res: Array<ContainerTransactionStatus>) => {
        this.containerTransactionStatussList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.containerTransactionStatussList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }

  getFilteredOptions() {
      return this.containerTransactionStatussList;
  }
}
